@let widgetRef =
  currentRendering.subfeatures.modal.selectors.widgetRef.asSignal();

@if (widgetRef) {
  @let info =
    currentRendering.subfeatures.widgets.selectors
      .getEntry(widgetRef)
      .asSignal();
  <atn-ds-centered-overlay
    (backdropClick)="backdropClickHandler()"
    [type]="
      info?.rendering?.type === WidgetTypeEnum.Questions ? 'wide' : 'narrow'
    "
  >
    <div class="atn-mosaic-modal">
      <!-- TODO: The `loading` input is a temporary workaround to show a loading
        state instead of an empty state when `info` is undefined. Ideally, this
        should be handled within the current rendering logic, ensuring the
        `info` object is initialized alongside the widget reference, with
        `loading` initially set to true. -->
      <atn-mosaic-widget
        [refId]="widgetRef.id"
        [rendering]="info?.rendering"
        [loading]="info?.isLoading ?? true"
        [error]="info?.error?.message"
        renderMode="modal"
      />
    </div>
  </atn-ds-centered-overlay>
}
